import { WOOTDASH_BASE, wootdashAuthHeaders } from '@/api/wootdash'

export interface CpSession {
  id: string
  device: string
  lastSeenAt: string
}

export async function listMySessions(token: string): Promise<CpSession[]> {
  try {
    const res = await fetch(`${WOOTDASH_BASE}/sessoes`, { headers: wootdashAuthHeaders(token) })
    if (!res.ok) return []
    return await res.json()
  } catch {
    return []
  }
}

/** Batimento desta sessão (POST /sessoes/heartbeat). 401 = sessão revogada (token recusado). */
export async function heartbeatSession(token: string): Promise<number> {
  try {
    const res = await fetch(`${WOOTDASH_BASE}/sessoes/heartbeat`, { method: 'POST', headers: wootdashAuthHeaders(token) })
    return res.status
  } catch {
    return 0
  }
}

// ── Sessões dos agentes (Ctrl+Shift+S, permissão sessions.manage) ──────────────────────────────

export interface AgentSessionItem { id: string; device: string; lastSeenAt: string; isCurrent: boolean; isMine: boolean }
export interface AgentSessions { agentId: string; name: string; email: string; avatarUrl: string | null; status: string; isActive: boolean; sessions: AgentSessionItem[] }

/** Mesma ordem do SessionRevokeScope do backend: 0 = sessão atual, 1 = demais abertas, 2 = todas. */
export type SessionRevokeScope = 0 | 1 | 2
export interface RevokeAgentSessionsResult { revoked: number; agents: { agentId: string; name: string; revoked: number }[] }

export async function listAgentSessions(token: string): Promise<AgentSessions[]> {
  const res = await fetch(`${WOOTDASH_BASE}/sessoes/agentes`, { headers: wootdashAuthHeaders(token) })
  if (res.status === 403) throw new Error('Seu perfil não tem a permissão "sessions.manage". Saia e entre de novo se ela acabou de ser liberada.')
  if (!res.ok) throw new Error('Não deu pra carregar as sessões.')
  return await res.json()
}

export async function revokeAgentSessions(token: string, agentIds: string[], scope: SessionRevokeScope): Promise<RevokeAgentSessionsResult> {
  const res = await fetch(`${WOOTDASH_BASE}/sessoes/agentes/revogar`, {
    method: 'POST',
    headers: { ...wootdashAuthHeaders(token), 'Content-Type': 'application/json' },
    body: JSON.stringify({ agentIds, scope }),
  })
  if (!res.ok) {
    const body = await res.json().catch(() => null)
    throw new Error(body?.error || 'Não deu pra revogar as sessões.')
  }
  return await res.json()
}

export async function revokeSession(token: string, id: string): Promise<boolean> {
  const res = await fetch(`${WOOTDASH_BASE}/sessoes/${id}/revogar`, { method: 'POST', headers: wootdashAuthHeaders(token) })
  return res.ok
}
